import React from 'react';
import "./index.scss";
import { Row, Col, Card } from 'react-bootstrap';
//import { Link } from 'react-router-dom';


class AppContact extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col md="4" sm="6">
                    <Card>
                        <Card.Body className="text-center">
                        <img alt="profile" className="rounded-circle margin-b-10" src="/assets/img/avtar-7.png" width={60} />
                        <p className="lead margin-b-0">John Doe</p>
                        <p className="text-muted">Turkey</p>
                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. </p>
                        <button className="btn btn-primary"><i className="demo-pli-male icon-fw" />Follow</button>
                        <hr />
                        <ul className="list-unstyled margin-b-0 text-center row">
                            <li className="col-4">
                            <span className="font-600">1,345</span>
                            <p className="text-muted text-sm margin-b-0">Following</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">23K</span>
                            <p className="text-muted text-sm margin-b-0">Followers</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">278</span>
                            <p className="text-muted text-sm margin-b-0">Post</p>
                            </li>
                        </ul>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md="4" sm="6">
                    <Card>
                        <Card.Body className="text-center">
                        <img alt="profile" className="rounded-circle margin-b-10" src="/assets/img/avtar-7.png" width={60} />
                        <p className="lead margin-b-0">John Doe</p>
                        <p className="text-muted">Turkey</p>
                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. </p>
                        <button className="btn btn-primary"><i className="demo-pli-male icon-fw" />Follow</button>
                        <hr />
                        <ul className="list-unstyled margin-b-0 text-center row">
                            <li className="col-4">
                            <span className="font-600">1,345</span>
                            <p className="text-muted text-sm margin-b-0">Following</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">23K</span>
                            <p className="text-muted text-sm margin-b-0">Followers</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">278</span>
                            <p className="text-muted text-sm margin-b-0">Post</p>
                            </li>
                        </ul>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md="4" sm="6">
                    <Card>
                        <Card.Body className="text-center">
                        <img alt="profile" className="rounded-circle margin-b-10" src="/assets/img/avtar-7.png" width={60} />
                        <p className="lead margin-b-0">John Doe</p>
                        <p className="text-muted">Turkey</p>
                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. </p>
                        <button className="btn btn-primary"><i className="demo-pli-male icon-fw" />Follow</button>
                        <hr />
                        <ul className="list-unstyled margin-b-0 text-center row">
                            <li className="col-4">
                            <span className="font-600">1,345</span>
                            <p className="text-muted text-sm margin-b-0">Following</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">23K</span>
                            <p className="text-muted text-sm margin-b-0">Followers</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">278</span>
                            <p className="text-muted text-sm margin-b-0">Post</p>
                            </li>
                        </ul>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md="4" sm="6">
                    <Card>
                        <Card.Body className="text-center">
                        <img alt="profile" className="rounded-circle margin-b-10" src="/assets/img/avtar-8.png" width={60} />
                        <p className="lead margin-b-0">John Doe</p>
                        <p className="text-muted">Turkey</p>
                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. </p>
                        <button className="btn btn-primary"><i className="demo-pli-male icon-fw" />Follow</button>
                        <hr />
                        <ul className="list-unstyled margin-b-0 text-center row">
                            <li className="col-4">
                            <span className="font-600">1,345</span>
                            <p className="text-muted text-sm margin-b-0">Following</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">23K</span>
                            <p className="text-muted text-sm margin-b-0">Followers</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">278</span>
                            <p className="text-muted text-sm margin-b-0">Post</p>
                            </li>
                        </ul>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md="4" sm="6">
                    <Card>
                        <Card.Body className="text-center">
                        <img alt="profile" className="rounded-circle margin-b-10" src="/assets/img/avtar-6.png" width={60} />
                        <p className="lead margin-b-0">John Doe</p>
                        <p className="text-muted">Turkey</p>
                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. </p>
                        <button className="btn btn-primary"><i className="demo-pli-male icon-fw" />Follow</button>
                        <hr />
                        <ul className="list-unstyled margin-b-0 text-center row">
                            <li className="col-4">
                            <span className="font-600">1,345</span>
                            <p className="text-muted text-sm margin-b-0">Following</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">23K</span>
                            <p className="text-muted text-sm margin-b-0">Followers</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">278</span>
                            <p className="text-muted text-sm margin-b-0">Post</p>
                            </li>
                        </ul>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md="4" sm="6">
                    <Card>
                        <Card.Body className="text-center">
                        <img alt="profile" className="rounded-circle margin-b-10" src="/assets/img/avtar-5.png" width={60} />
                        <p className="lead margin-b-0">John Doe</p>
                        <p className="text-muted">Turkey</p>
                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. </p>
                        <button className="btn btn-primary"><i className="demo-pli-male icon-fw" />Follow</button>
                        <hr />
                        <ul className="list-unstyled margin-b-0 text-center row">
                            <li className="col-4">
                            <span className="font-600">1,345</span>
                            <p className="text-muted text-sm margin-b-0">Following</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">23K</span>
                            <p className="text-muted text-sm margin-b-0">Followers</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">278</span>
                            <p className="text-muted text-sm margin-b-0">Post</p>
                            </li>
                        </ul>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md="4" sm="6">
                    <Card>
                        <Card.Body className="text-center">
                        <img alt="profile" className="rounded-circle margin-b-10" src="/assets/img/avtar-5.png" width={60} />
                        <p className="lead margin-b-0">John Doe</p>
                        <p className="text-muted">Turkey</p>
                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. </p>
                        <button className="btn btn-primary"><i className="demo-pli-male icon-fw" />Follow</button>
                        <hr />
                        <ul className="list-unstyled margin-b-0 text-center row">
                            <li className="col-4">
                            <span className="font-600">1,345</span>
                            <p className="text-muted text-sm margin-b-0">Following</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">23K</span>
                            <p className="text-muted text-sm margin-b-0">Followers</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">278</span>
                            <p className="text-muted text-sm margin-b-0">Post</p>
                            </li>
                        </ul>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md="4" sm="6">
                    <Card>
                        <Card.Body className="text-center">
                        <img alt="profile" className="rounded-circle margin-b-10" src="/assets/img/avtar-5.png" width={60} />
                        <p className="lead margin-b-0">John Doe</p>
                        <p className="text-muted">Turkey</p>
                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. </p>
                        <button className="btn btn-primary"><i className="demo-pli-male icon-fw" />Follow</button>
                        <hr />
                        <ul className="list-unstyled margin-b-0 text-center row">
                            <li className="col-4">
                            <span className="font-600">1,345</span>
                            <p className="text-muted text-sm margin-b-0">Following</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">23K</span>
                            <p className="text-muted text-sm margin-b-0">Followers</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">278</span>
                            <p className="text-muted text-sm margin-b-0">Post</p>
                            </li>
                        </ul>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col md="4" sm="6">
                    <Card>
                        <Card.Body className="text-center">
                        <img alt="profile" className="rounded-circle margin-b-10" src="/assets/img/avtar-5.png" width={60} />
                        <p className="lead margin-b-0">John Doe</p>
                        <p className="text-muted">Turkey</p>
                        <p className="text-sm">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. </p>
                        <button className="btn btn-primary"><i className="demo-pli-male icon-fw" />Follow</button>
                        <hr />
                        <ul className="list-unstyled margin-b-0 text-center row">
                            <li className="col-4">
                            <span className="font-600">1,345</span>
                            <p className="text-muted text-sm margin-b-0">Following</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">23K</span>
                            <p className="text-muted text-sm margin-b-0">Followers</p>
                            </li>
                            <li className="col-4">
                            <span className="font-600">278</span>
                            <p className="text-muted text-sm margin-b-0">Post</p>
                            </li>
                        </ul>
                        </Card.Body>
                    </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default AppContact;
